import AdapterNativeIcon from "./adapter-native-icon";
import licenseService from "../../../../core/services/metaStoreService/license-service";

const colors = {
    source: "#346CC2",
    target: "#2E8071"
};

const OutlinedIcon = ({ name, type, size }) => {
    const Icon = icons?.[name];
    if (!Icon) return null;
    const color = type === "source" ? colors.source : colors.target;
    return <Icon style={{ width: size, height: size, fill: color }} />;
};

export const AdapterIcon = ({
    name,
    type,
    size,
    adapter = null,
    tooltip = null,
    useNative = false,
    spriteId = undefined,
    newlyReleased = false,
    showBorder = true,
    outlined = false
}) => {
    const isAddOn =
        (adapter === "DeltaLakeWriter" || adapter === "FabricDataWarehouseWriter") && licenseService.isLiteLicense;

    if (useNative) {
        return (
            <AdapterNativeIcon
                name={name}
                type={type}
                tooltip={tooltip}
                size={size}
                spriteId={spriteId}
                newlyReleased={newlyReleased}
                showBorder={showBorder}
                isAddOn={isAddOn}
            />
        );
    }
    if (outlined) {
        return <OutlinedIcon name={name} type={type} size={size} />;
    }
    return <></>;
};

